import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import TackledByPositionPref from "./position-pref/tackled-by-position-pref";
import OOBTacklerDefaultValue from "./default-value/oob-tackler-default-value";

export default class OutOfBounds extends Fragment {
    constructor(tackledBy = null) {
        super();

        if (tackledBy !== null && !Array.isArray(tackledBy)) {
            this.tackledBy = [tackledBy];
        } else {
            this.tackledBy = tackledBy;
        }

        this.requiredData = [
            {
                name: "tackledBy",
                type: FragmentDataType.Players,
                maxPlayers: 2,
                appliesToOpponent: () => true,
                displayName: "Tackle by",
                title: (team) => `Tackle By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true,
                optional: true,
                isSkipped: () => this.tackledBy && this.tackledBy.length === 0,
                positionPref: (play) =>
                    new TackledByPositionPref(play, this).resolve(),
                defaultValue: ({ play, summaryContext, team }) => {
                    return new OOBTacklerDefaultValue(
                        play,
                        this,
                        summaryContext,
                        team
                    ).resolve();
                }
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const players = this.getPlayers();
        const tackledBy = players.length
            ? ` (${players.map((p) => stringifier.firstInitial(p)).join(", ")})`
            : "";

        const { gameConfig, fieldPosition } = summaryContext;
        return new FragmentSummary(
            `out-of-bounds at the ${stringifier.niceFieldPosition(
                gameConfig.general.fieldLength,
                fieldPosition,
                summaryContext.homeTeam?.abbrName,
                summaryContext.awayTeam?.abbrName
            )}${tackledBy}`
        );
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    getPlayers() {
        return this.tackledBy?.filter((p) => p.id) || [];
    }

    toJSON() {
        return {
            ...super.toJSON(),
            tackledBy: this.tackledBy?.map((p) => playerReducer(p))
        };
    }
}
